import moment from 'moment'
import * as Redux from 'redux'
import * as Form from '../../components/form'
import * as Modal from '../../components/modal'
import * as Pager from '../../components/pager'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as CommunityConfig from '../community-config'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

interface SearchAction extends Redux.Action {
  term: string,
}

const emptySearchState: Types.SearchState = {
  term: '',
}
export const searchReducer = (state: Types.SearchState = emptySearchState, action: SearchAction) => {
  switch (action.type) {
    case Constants.UPDATE_COMMUNITY_SEARCH_STRING:
      return {
        ...state,
        term: action.term,
      }
    default:
      return state
  }
}

const communitiesFormReducer = (sourceReducer: any) =>
  (state: Form.State<any>, action: any ) => {
    const sourceState = sourceReducer(state, action);
    switch (action.type) {
      case Request.successConstant(Constants.UPDATE_COMMUNITY):
        return {
          ...sourceState,
          fields: {},
        }
      default:
        return sourceState
    }
  }

const modalReducerEvent: Modal.ReducerEvent<{}> = {
  initializeState: () => ({}),
  requestEvent: Constants.EXPIRE_COMMUNITY,
  toggleEvent: Actions.FormConstants[Form.ENTER],
}

export interface ModalState {isOpen: boolean}
export const modalReducer = (state: Modal.State<Types.FormFields>, action: any) => {
  switch (action.type) {
    case Request.successConstant(Constants.UPDATE_COMMUNITY):
      return {
        ...state,
        isOpen: false,
      }
    default:
      return state
  }
}

const normalizeTypes: Sortable.TypeNormalizer<CommunityConfig.Community> = (
  payload: Sortable.SortableData<CommunityConfig.Community>): Sortable.SortableData<CommunityConfig.Community> => {
  return payload.map((c: CommunityConfig.Community) => ({
    ...c,
    created_datetime: moment(c.created),
    expiration_datetime: moment(c.expiration_date),
  }))
}

const reducerEvent: Sortable.ReducerEvent<CommunityConfig.Community> = {
  defaultSort: { field: 'id', dir: 'desc' },
  normalizer: normalizeTypes,
  requestEvent: CommunityConfig.FETCH_COMMUNITIES,
}

export const reducer = Redux.combineReducers({
  data: Sortable.stateReducer(reducerEvent),
  form: communitiesFormReducer(Form.createReducer(Constants.EXPIRE_COMMUNITY)),
  modal: Request.reducerChain([modalReducer, Modal.reducer(modalReducerEvent)]),
  page: Pager.createReducer(Constants.FETCH_COMMUNITIES),
  search: searchReducer,
  view: Sortable.viewReducer(reducerEvent),
})



// WEBPACK FOOTER //
// ./src/pages/communities/reducer.ts